import _ from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'

import http from '../../lib/http'
import MagicGrid from '../shared/MagicGrid'
import {
  Button,
  ErrorMessage,
  Pagination
} from '../shared/NarusMaterial'

const SORT = {
  0: 'patient_first_name',
  1: 'patient_last_name',
  2: 'assignee_first_name',
  3: 'assignee_last_name',
  4: 'assignee_email',
  5: 'assignee_enabled',
  6: 'issue_title',
  7: 'issue_status',
  8: 'issue_open_action_count',
  9: 'client_name',
  10: 'client_status'
}

const doRequest = ({ page, on, dir, filter, request }) => {
  const count = 50
  const params = _.assign(
    {
      count,
      page,
      dir,
      on: SORT[on]
    },
    filter
  )
  return dispatch => {
    dispatch({
      type: 'admin/igao/loading',
      filter
    })
    return request(params)
      .then(result => {
        const paging = {
          count: result.count,
          total: result.total,
          page
        }
        const sort = {
          on,
          dir
        }
        return dispatch({
          type: 'admin/igao/loaded',
          data: result.data,
          paging,
          sort,
          filter
        })
      })
      .catch(error =>
        dispatch({
          type: 'admin/igao/error',
          error: error.toString()
        }))
  }
}

const loadRecords = ({ page, on, dir, filter }) =>
  doRequest({
    page,
    on,
    dir,
    filter,
    request: params => http.getRequest('/admin/igao', params)
  })

const cancelRecords = ({ page, on, dir, filter, rows }) =>
  doRequest({
    page,
    on,
    dir,
    filter,
    request: params =>
      http.postRequest('/admin/igao/cancel', _.merge({ rows }, params))
  })

class OrphanIGAO extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { dispatch } = this.props
    const headers = [
      {
        displayFn: r => r.patient_first_name,
        title: 'Patient First'
      },
      {
        displayFn: r => r.patient_last_name,
        title: 'Patient Last'
      },
      {
        displayFn: r => r.assignee_first_name,
        title: 'Assignee First'
      },
      {
        displayFn: r => r.assignee_last_name,
        title: 'Assignee Last'
      },
      {
        displayFn: r => r.assignee_email,
        title: 'Assignee Email'
      },
      {
        displayFn: r => `${!!r.assignee_enabled}`,
        title: 'Assignee Enabled'
      },
      {
        displayFn: r => r.issue_title,
        title: 'Issue Title'
      },
      {
        displayFn: r => r.issue_status,
        title: 'Issue Status'
      },
      {
        displayFn: r => r.issue_open_action_count,
        title: 'Issue Open Action Count'
      },
      {
        displayFn: r => r.client_name,
        title: 'Client Name'
      },
      {
        displayFn: r => r.client_status,
        title: 'Client Status'
      }
    ]
    const records = {
      loading: _.get(this.props, 'igao.loading'),
      error: _.get(this.props, 'igao.error'),
      data: _.get(this.props, 'igao.data', []),
      count: _.get(this.props, 'igao.paging.count', 0),
      page: _.get(this.props, 'igao.paging.page', 0),
      total: _.get(this.props, 'igao.paging.total', 0),
      sort: {
        on: _.get(this.props, 'igao.sort.on', 0),
        dir: _.get(this.props, 'igao.sort.dir', 'asc')
      },
      filter: _.get(this.props, 'igao.filter', {})
    }
    const pages =
      Math.floor(records.total / records.count) +
        (records.total % records.count > 0 && 1) || 0
    const rows = records.data
    const onSort = value => {
      dispatch(
        loadRecords({
          page: 0,
          on: value.index,
          dir: value.direction,
          filter: records.filter
        })
      )
    }
    const onPagination = value => {
      dispatch(
        loadRecords({
          page: value - 1,
          on: records.sort.on,
          dir: records.sort.dir,
          filter: records.filter
        })
      )
    }
    const onCancel = () => {
      if (window.confirm('Are you sure?')) {
        dispatch(
          cancelRecords({
            page: records.page,
            on: records.sort.on,
            dir: records.sort.dir,
            filter: records.filter,
            rows: rows.map(r => _.pick(r, [ 'id', 'client' ]))
          })
        )
      }
    }
    return (
      <div className='igao root'>
        <div className='igao records'>
          <h1
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline'
            }}
          >
            <b>Orphan IGAOs</b>
          </h1>
          <h2
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline'
            }}
          >
            IGAO
            <Button
              label={`Cancel ${rows.length} issue(s)`}
              onClick={onCancel}
              purple
              key='cancel'
              disabled={_.isEmpty(rows)}
            />
            {(records.total > 0 && (
              <div className='total-records'>
                {' '}
                {records.page * records.count + 1}
                –
                {' '}
                {records.page * records.count + records.data.length}
                {' '}
                of
                {' '}
                {records.total}
                {' '}
                {' records'}
                {' '}
              </div>
            )) || <div className='total-records'> 0 records </div>}
          </h2>
          <MagicGrid
            loading={records.loading}
            rows={rows}
            headers={headers}
            canDelete={false}
            itemName='records'
            onSort={onSort}
            sortOn={records.sort.on}
            sortDir={records.sort.dir}
            showCounter={false}
          />
          {(records.error && (
            <div className='row'>
              <div className='col-xs-12'>
                <ErrorMessage errors={[ records.error ]} />
              </div>
            </div>
          )) || (
            <div className='card-pagination-row'>
              <Pagination
                onChange={onPagination}
                totalPages={pages}
                currentPage={records.page + 1}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default connect(redux => ({
  igao: _.get(redux, 'admin.igao', {})
}))(OrphanIGAO)
